export default __webpack_public_path__ + "static/media/kwp-logo.3b886bde.svg";